<template>
  <vx-tooltip :text="$t('buttons.back')" class="self-center -mr-3" position="bottom">
    <vs-button @click="goBack" class="px-3" type="flat">
      <BaseIcon fixed-width name="arrow-left"></BaseIcon>
    </vs-button>
  </vx-tooltip>
</template>

<script>
  export default {
    name: "back-button",
    methods: {
      goBack () {
        window.history.back()
      }
    }
  }
</script>

<style scoped>

</style>
